
import ApplicationTitle from '../../components/ApplicationTitle';
import StackedTitle from '../../components/form_titles/StackedTitle';
import MainButton from '../../components/buttons/MainButton';
import Plans from '../../components/plans/PromoPlans';


export default function Prices({ nextStep, changeVal, prevStep, values }) {
  // console.log(changeVal)
  return (
    <div className="bg-white-900 dark:bg-white-900 mt-12">
        <div className='App-header'>
            <Plans nextStep = {nextStep} values = {values} changeVal = {changeVal}></Plans>
        </div>
    </div>
  );
}